import './SuggestionButton.scss';
import classNames from 'classnames';
import { SparkleIcon } from './SparkleIcon';
import { TooltipPlacement } from 'antd/es/tooltip';
import { AUTODOC_TYPE_LABELS, AutodocType } from '@sonar-software/sonar-core';
import { Button, Tooltip } from 'antd';
import React, { useCallback } from 'react';

export interface SuggestionButtonProps {
	className?: string;
	onClick: () => void;
	placement?: TooltipPlacement;
	autodocType: AutodocType;
}

export const SuggestionButton: React.FC<SuggestionButtonProps> = ({
	className,
	onClick,
	placement = 'bottom',
	autodocType
}) => {
	const tooltip = `Suggest ${AUTODOC_TYPE_LABELS[ autodocType ]}`;

	const handleClick = useCallback(
		(e: React.MouseEvent) => {
			e.stopPropagation();

			onClick();
		},
		[ onClick ]
	);

	return (
		<div className={ classNames('suggestion-button', className) }>
			<Tooltip
				mouseEnterDelay={ 0.5 }
				placement={ placement }
				title={ tooltip }>
				<Button
					icon={ <SparkleIcon /> }
					onClick={ handleClick }
					tabIndex={ -1 } />
			</Tooltip>
		</div>
	);
};
